import SendMessageForm from './SendMessageForm.vue';
import SimpleActionForm from './SimpleActionForm.vue';
import KanbanActionForm from './KanbanActionForm.vue';
import ContactAttributeForm from './ContactAttributeForm.vue';
import SendCampaignForm from './SendCampaignForm.vue';
import CreateContactForm from './CreateContactForm.vue';
import SendEmailContactForm from './SendEmailContactForm.vue';
import CreateKanbanTaskForm from './CreateKanbanTaskForm.vue';
import MoveKanbanTaskForm from './MoveKanbanTaskForm.vue';
import UpdateKanbanTaskForm from './UpdateKanbanTaskForm.vue';

export const ACTION_FORM_REGISTRY = {
  assign_agent: SimpleActionForm,
  assign_team: SimpleActionForm,
  remove_assigned_agent: null,
  remove_assigned_team: null,
  add_label: SimpleActionForm,
  remove_label: SimpleActionForm,
  send_message: SendMessageForm,
  send_email_to_team: SimpleActionForm,
  mute_conversation: null,
  snooze_conversation: SimpleActionForm,
  resolve_conversation: null,
  open_conversation: null,
  pending_conversation: null,
  send_webhook_event: SimpleActionForm,
  add_private_note: SimpleActionForm,
  change_priority: SimpleActionForm,
  assign_to_board: KanbanActionForm,
  move_to_step: KanbanActionForm,
  add_contact_note: SimpleActionForm,
  update_contact_attribute: ContactAttributeForm,
  send_campaign: SendCampaignForm,
  create_or_update_contact: CreateContactForm,
  send_email_to_contact: SendEmailContactForm,
  create_kanban_task: CreateKanbanTaskForm,
  move_kanban_task: MoveKanbanTaskForm,
  update_kanban_task: UpdateKanbanTaskForm,
  add_sla: SimpleActionForm,
  add_to_segment: SimpleActionForm,
  remove_from_segment: SimpleActionForm,
};
